import React from 'react'
import {useItemVariant} from '@salesforce/retail-react-app/app/components/item-variant'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import {rebuildPathWithParams} from '../../utills/url'

/**
 * In the context of a cart product item variant, this components simply renders
 * the item's name using the cart item field `productName`. We use this field
 * rather than variant `name` field as the variant detail may not yet be
 * available upon rendering.
 */
const ItemName = (props) => {
    const variant = useItemVariant()
    let productUrl
    if (variant.slugUrl) {
        const url = new URL(variant.slugUrl)
        productUrl = rebuildPathWithParams(url.pathname, {cgid: variant.c_primaryCatergoryID})
    }

    return (
        <Heading as="h2" fontSize="md">
            <Link {...props} color="black.600" to={productUrl || '#'}>
                {variant.name || variant.productName}
            </Link>
        </Heading>
    )
}

export default ItemName
